import { HTMLAttributes } from "react"
import { FilledArrow } from "../../utils/iconFactory"
import { classNames } from "../../utils/utils"

interface TooltipProps extends HTMLAttributes<HTMLDivElement> {
  message: string
  widthPx?: number
}

export default function Tooltip({message, widthPx, className, ...props}: TooltipProps) {
  // widthPx/2-21
  const stringToCenterCustomWidth = widthPx ? `w-[${widthPx}px] -translate-x-[126.5px] left-auto right-auto` : "left-0 right-0"

  return (
    <div className={classNames("absolute bottom-full invisible group-hover:visible",
      "z-30 flex flex-col items-center justify-center cursor-pointer",
      className, stringToCenterCustomWidth)}
      {...props}
    >
      <div className="p-3 rounded-[8px] bg-textMain text-backgroundWhite text-style-small tooltip-drop-shadow">
        {message}
      </div>
      <FilledArrow className="flex h-[19px] w-[17px] text-textMain -translate-y-[8px] fill-current" />
    </div>
  )
}


export function TooltipRight() {
  return (
    <div className={classNames("absolute invisible group-hover:visible",
      "z-30 flex flex-row gap-2 cursor-pointer",
      "w-[295px] left-full -translate-y-[18px] -translate-x-[5px]")}
    >
      <div className="flex">
        <FilledArrow className="flex-none h-[19px] w-[17px] text-textMain translate-x-3 translate-y-[18px] fill-current transform rotate-90" />
      </div>
      <div className="flex flex-col gap-2 p-3 rounded-[8px] bg-textMain text-backgroundWhite text-style-small text-left tooltip-drop-shadow">
        <p className="text-style-body2-bold">Szöveg generálás</p>
        <p>Az alábbi mezőben add meg a témát és opcionálisan egy rövid ismertetőt, amiről szeretnél leírást generálni. A “További beállítások megadása” gombra kattintva kerülendő és használandó szavakat adhatsz hozzá, illetve beállíthatsz egy maximum karakterszámot is.</p>
        <p>Miután megadtad a leírást, kattins a “Generálás” gombra. AIDA ezután a lentebb látható üres mezőben fogja leírni a generált szöveget. A kész szövegezést a képernyő közepén látható nyíl gomb segítségével átviheted a jobb oldali mezőbe, ahol kedvedre szerkesztheted a leírást.</p>
      </div>
    </div>
  )
}